module.exports = __webpack_public_path__ + "static/media/wrinkles_nasolabial.11b98166.svg";